<template>
  <div class="u-user" :class="classes">
    <u-dropdown
      @on-visible-change="visibleChange"
      @on-click="logout"
      :trigger="trigger"
    >
      <span class="u-user-name">
        <Avatar
          class="u-user-avatar"
          v-if="userInfo.avatar"
          :src="userInfo.avatar"
        />
        <Avatar class="u-user-avatar" v-else style="background-color: #0065FF;">
          <span>{{ userInfo.name.slice(0, 1) }}</span>
        </Avatar>
        <span style="vertical-align: middle;">{{ userInfo.name }}</span>
        <!--超级管理员-->
        <Icon type="ios-arrow-up" class="u-user-arrow" />
        <!--<Icon type="ios-arrow-down" ></Icon>-->
      </span>
      <DropdownMenu slot="list">
        <DropdownItem :name="userCenter">账号中心</DropdownItem>
        <DropdownItem :name="logoutName">退出登录</DropdownItem>
      </DropdownMenu>
    </u-dropdown>
    <!--<u-select></u-select>-->
  </div>
</template>

<script>
import uDropdown from "../u-Dropdown";
import { mapActions, mapGetters } from "vuex";
import "@/styles/component/user.less";
export default {
  name: "user",
  data() {
    return {
      trigger: "click",
      visible: false,
      userCenter: "userCenter",
      logoutName: "loginOut"
    };
  },
  methods: {
    ...mapActions(["handleLogout"]),
    visibleChange(visible) {
      this.visible = visible;
    },
    logout(name) {
      if (name === this.logoutName) {
        //退出登录
        this.handleLogout().then(() => {
          this.$router.push({
            name: "login"
          });
        });
      }
      if (name === this.userCenter) {
        //个人中心
        this.$router.push({
          path: "/user-center"
        });
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    classes() {
      return [
        {
          "u-user-visible": this.visible
        }
      ];
    }
  },
  components: {
    uDropdown
  }
};
</script>
